<app-ion-common-header [id]="headerId" (backHeader)="backPage()" (focusHeader)="shownContent()" [title]="titlePage" start="{{startStage}}" end="{{endStage}}"></app-ion-common-header>

<ion-content [attr.aria-hidden]="ariaHidden" [style.visibility]="ariaHidden ? 'hidden' : 'visible'">
  
<app-ion-common-label class="document-type-label1" labelStyle="display-rg"
  [labelDescription]="titleLabelPage">
</app-ion-common-label>

<div class="conent-center conent-center--mrt-lg">
  <form [formGroup]="dateBirthForm" (ngSubmit)="submitForm($event)">
      <app-ion-common-input
        [placeholder]="placeholder" 
        [error]="error" 
        [id]="idComponentName"
        [textError]="textError"
        minLength="10"
        maxLength="10"
        (textChange)="birthData=$event; errorMsg();"
        type="tel"
        [fieldValue]="birthData"
        [idLabel]="idLabel"
        [replaceStrTo]="'date'"
        [label]="label"
        name="docDateBirth"
        [disabled]="!this.edit"
        formControlName="docDateBirth"
        ngDefaultControl>
      </app-ion-common-input>
    </form>
  </div>
  <app-ion-common-button class="hidden" [ngClass]="{'hidden': !buttonEnable || birthData?.length === 0}" [attr.aria-hidden]="!buttonEnable" (clickButton)="clickNext();" label="Continuar"></app-ion-common-button>
</ion-content>